import {
  RadioGroup,
  Radio,
  RadioButton,
  Label,
  Description,
  ChildContainer,
  Buttons,
  Error
} from './styles'

RadioGroup.Radio = Radio
RadioGroup.RadioButton = RadioButton
RadioGroup.Label = Label
RadioGroup.Description = Description
RadioGroup.ChildContainer = ChildContainer
RadioGroup.Buttons = Buttons
RadioGroup.Error = Error

export default RadioGroup
